import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { SegmentedButtons } from '@comparethemarketau/manor-buttongroup';
import { Typography } from '@comparethemarketau/manor-typography';

import { connect } from 'react-redux';

import { paymentFrequencyStateMapping, paymentFrequencyDispatchMapping, frequencyFilterTypes } from './filter_store_mapping';

const useStyles = createUseStyles((theme) => ({
    subtitle: {
        color: theme.colors.grey700,
        fontSize: theme.fontSize.sm
    }
}));

const _PaymentFrequencyFilterButtonGroup = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { frequencyFilter, stageChange, onChange } = props;
    const [value, setValue] = useState(frequencyFilter);

    const handleToggle = (toggleValue) => {
        setValue(toggleValue);
        stageChange(toggleValue);
        if (onChange) {
            onChange(toggleValue !== frequencyFilter);
        }
    };

    return (
        <div className={classNames('test-policyFilters-paymentFrequency')}>
            <SegmentedButtons
                label={(
                    <div>
                        <Typography>Payment Frequency</Typography>
                        <Typography className={classes.subtitle}>Choose between paying monthly or annually. You may save money with some providers by paying annually</Typography>
                    </div>
                )}
                trackingLabel="Segmented buttons for payment frequency"
                flex
                name="paymentFrequencyButtons"
                buttonsContent={
                    [
                        {
                            label: 'Monthly',
                            value: 'monthly'
                        },
                        {
                            label: 'Annually',
                            value: 'annual'
                        }
                    ]
                }
                handleToggle={handleToggle}
                selectedValue={value}
            />
        </div>
    );
};

_PaymentFrequencyFilterButtonGroup.propTypes = {
    frequencyFilter: PropTypes.oneOf(frequencyFilterTypes),
    stageChange: PropTypes.func,
    onChange: PropTypes.func
};

const PaymentFrequencyFilterButtonGroup = connect(paymentFrequencyStateMapping, paymentFrequencyDispatchMapping)(_PaymentFrequencyFilterButtonGroup);

export { PaymentFrequencyFilterButtonGroup };
